import { cn } from '@/lib/utils';

const SIZES = {
  sm: 'h-3.5 w-3.5 text-[9px]',
  md: 'h-6 w-6 text-[13px]',
  lg: 'h-10 w-10 text-xl',
} as const;

/**
 * The yellow "!" that marks everything about "Vi har brug for din hjælp her":
 * the page header, the Projekter nav badge, the Trackrs card banner and the
 * first-visit modal. The one place amber is used for this feature — the rest of
 * the UI stays on the ordinary palette, because none of it is a warning.
 */
export function AttentionMark({ size = 'md', className }: { size?: keyof typeof SIZES; className?: string }) {
  return (
    <span
      aria-hidden="true"
      className={cn(
        'inline-flex shrink-0 select-none items-center justify-center rounded-full bg-amber-400 font-bold leading-none text-white shadow-sm',
        SIZES[size],
        className,
      )}
    >
      !
    </span>
  );
}
